(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-check', {
            parent: 'entity',
            url: '/phone-call-check?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallCheck.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-check/phone-call-checks.html',
                    controller: 'PhoneCallCheckController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'checkTime,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallCheck');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-check-detail', {
            parent: 'phone-call-check',
            url: '/phone-call-check/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallCheck.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-detail.html',
                    controller: 'PhoneCallCheckDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallCheck');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallCheck', function($stateParams, PhoneCallCheck) {
                    return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-check',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-check-detail.edit', {
            parent: 'phone-call-check-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        // Need in phone-call-check/phone-call-check/{id}/detail/edit
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCall');
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-check.new', {
            parent: 'phone-call-check',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        // Need in phone-call-check/new, but not applied in our case.
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCall');
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                dummy: false,
                                assessment: null,
                                comment: null,
                                checkerCaption: null,
                                checkTime: null,
                                systemic: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-check', null, { reload: 'phone-call-check' });
                }, function() {
                    $state.go('phone-call-check');
                });
            }]
        })
        .state('phone-call-check.edit', {
            parent: 'phone-call-check',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        // Need in phone-call-check/{id}/edit
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCall');
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-check', null, { reload: 'phone-call-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-check.delete', {
            parent: 'phone-call-check',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-delete-dialog.html',
                    controller: 'PhoneCallCheckDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-check', null, { reload: 'phone-call-check' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
